module.exports = __webpack_public_path__ + "img/Payment-Platform.b27a1776.png";